import type { PageColumnsProps } from "../types/layout.js";

export function PageColumns({ children, aside }: PageColumnsProps) {
  return (
    <div className="grid items-start gap-6 xl:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)]">
      <div className="min-w-0 space-y-5">{children}</div>
      <aside className="min-w-0 space-y-5">{aside}</aside>
    </div>
  );
}
